import {
  authError,
  checkSession,
  isAdmin,
  isConsentRequired,
  isGranted,
  isPatient,
  isProfessional,
  sessionState,
  user
} from 'src/services/session.js'
import { auth } from 'src/services/auth.js'

export { user }

let instance = null

/**
 * @deprecated Use session or auth services instead
 *
 * This composable doesn't have useful code anymore, but we are keeping it for now to avoid editing all the codebase.
 * We will use LLM to find and update all usages
 */
export function useAuth() {
  if (instance) {
    return instance
  }

  async function onCheckSession(targetRoute = undefined, retry = false) {
    await checkSession(targetRoute, retry)
  }

  instance = {
    user,
    granted: isGranted,
    isAdmin,
    isPatient,
    isProfessional,
    isConsentRequired,
    sessionState,
    onCheckSession,
    error: authError,
    loggingIn: auth.loggingIn,
    loggingOut: auth.loggingOut,
    onLogout: auth.logout,
    onLogin: auth.login
  }

  return instance
}
